import CourseFilter from './CourseFilter';

export default CourseFilter;
